<template>

  <div class="formulario">
    <b-card no-body>
      <b-card-group deck>
        <b-card header="Mis Cuentas" bg-variant="light">

          <b-row>
            <b-col>
              <b-table striped hover bordered small stacked="sm" :items="cuentas" :fields="fields">
                
                <template v-slot:cell(ver_movimientos)="row">
                  <!-- v-if="(row.item.codigo_cuenta == 'AH') || (row.item.codigo_cuenta == 'PR')" -->
                  <b-button size="sm" @click="toggleDetails(row)" class="mr-2" variant="outline-primary">
                    <i class="fas fa-eye"> </i> 
                     {{ row.detailsShowing ? 'Ocultar' : 'Ver'}}
                  </b-button>
                </template>
                
                <template v-slot:row-details="row">
                  <b-card header="Movimientos de la cuenta" bg-variant="light">
                    <b-row>
                      
                      <b-col>  
                          <b-form-select v-model="fechas.mes" :options="meses" required />
                      </b-col>
                      
                      <b-col>             
                          <b-form-select v-model="fechas.anho" :options="anhos" required />    
                      </b-col>
                      
                      <b-col>          
                          <b-button size="sm" @click="getMovimientos(row.item,row.index,$event.target)" variant="outline-success" block>
                             <i class="fas fa-search"></i>
                            Buscar
                          </b-button> 
                      </b-col>       
                    
                    </b-row>
                    <b-row class="mt-3">
                      <b-col>
                        <b-table striped hover bordered small stacked="sm" :items="movimientos" :fields="fields_movimientos">
                          
                          <!-- A custom formatted column -->
                          <template v-slot:cell(debito2)="row">
                            <span :class="row.item.debito > 0 ? 'texto_rojo' : 'text-right'">{{ formatNumber(row.item.debito) }}</span>
                          </template>

                          <!-- A custom formatted column -->
                          <template v-slot:cell(credito2)="row">
                            <span :class="row.item.credito > 0 ? 'texto_verde' : 'text-right'">{{ formatNumber(row.item.credito) }}</span>
                          </template>

                        </b-table>
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                      <b-col>
                        <b-button size="sm" @click="row.toggleDetails">Ocultar Movimientos</b-button>
                      </b-col>
                    </b-row> -->
                    
                  </b-card>
                </template>
              </b-table>
            </b-col>
          </b-row>
          
        </b-card>
      </b-card-group>
    </b-card>
  </div>

</template>

<script>

import axios from "axios";
import moment from "moment";

export default {
  name: 'miscuentas',
  data() {
    return {
      title: 'Mis Cuentas',
      fechas : {
        mes: moment().format('M'),
        anho: moment().format('YYYY')
      },
      meses: [
        { value: 1, text: 'Enero'},
        { value: 2, text: 'Febrero'},
        { value: 3, text: 'Marzo'},
        { value: 4, text: 'Abril'},
        { value: 5, text: 'Mayo'},
        { value: 6, text: 'Junio'},
        { value: 7, text: 'Julio'},
        { value: 8, text: 'Agosto'},
        { value: 9, text: 'Setiembre'},
        { value: 10, text: 'Octubre'},
        { value: 11, text: 'Noviembre'},
        { value: 12, text: 'Diciembre'},
      ],
      anhos: [
        { value: 2019, text: '2019'},
        { value: 2020, text: '2020'},
        { value: 2021, text: '2021'},
        { value: 2022, text: '2022'},
      ],
      cuentas: [],
      fields: [
        {
          key: 'nro_cuenta',
          label: '# Cuenta',
          sortable: false,
        },
        {
          key: 'nombre_cuenta',
          label: 'Cuenta',
          sortable: false
        },
        {
          key: 'tipo_cuenta',
          label: 'Tipo',
          sortable: false
        },
        {
          key: 'saldo_cuenta',
          label: 'Saldo Gs.',
          sortable: true,
          class: 'text-right texto_negrita',
          formatter: (value, key, item) => {
            return this.formatNumber(value)
          }
        },
        {
          key: 'ver_movimientos',
          label: 'Movimientos',
          class: 'text-right',
        }
        
      ],
      movimientos: [], 
      fields_movimientos : [
        {
          key: 'fecha_movimiento',
          label: 'Fecha',
          sortable: false,
          formatter: (value, key, item) => {
            return moment(value).utc().format('DD/MM/YYYY');
          }
        },
        {
          key: 'nro_documento',
          label: 'Documento #',
          sortable: false,
        },
        {
          key: 'descripcion',
          label: 'Descripcion',
          sortable: false,
        },
        {
          key: 'debito2',
          label: 'Débito',
          sortable: true,
          //tdClass: 'text-right texto_rojo',
          tdClass: 'text-right',
          formatter: (value, key, item) => {
            return this.formatNumber(value)
          }
        },
        {
          key: 'credito2',
          label: 'Crédito',
          sortable: true,
          //tdClass: 'text-right texto_verde',
          tdClass: 'text-right',
          formatter: (value, key, item) => {
            return this.formatNumber(value)
          }
        },
        {
          key: 'saldo',
          label: 'Saldo',
          sortable: true,
          tdClass: 'text-right texto_negrita',
          formatter: (value, key, item) => {
            return this.formatNumber(value)
          }
        },
      ]
    };
  },
  methods: {
    // rowClass(item, type) {
    //   console.log(item)
    //   console.log(type)
    //   if (!item || type !== 'row') return
    //   if (item.status === 'awesome') return 'table-success'
    // },
    toggleDetails(row) {
    
      if(row.item._showDetails){
        this.$set(row.item, '_showDetails', false)
      }else{
        this.cuentas.forEach(item => {
          this.$set(item, '_showDetails', false)
        })

        this.$nextTick(() => {
          this.$set(row.item, '_showDetails', true)
        })
      }

      this.movimientos = [];
      this.getMovimientos(row.item, row.index, null);
    },
    async getCuentas() {
      const loader = this.$loading.show();
      try {
         const socio = await axios.post(`${process.env.VUE_APP_API_URL}/consulta/socio`, {
          socio_numero: +window.localStorage.getItem("nro_socio")
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
        return socio.data.cuentas
      } catch (error) {
         console.log(error.message)
      } finally {
        loader.hide();
      }
     
    },
    async getMovimientos(item, index, e) {
      //console.log(item)
      const loader = this.$loading.show();
      try {
        const rows = await axios.post(`${process.env.VUE_APP_API_URL}/consulta/saldo_cuenta`, {
          cartera: item.codigo_cuenta,
          socio_numero: item.nro_socio,
          nro_cuenta: item.nro_cuenta,
          month: this.fechas.mes,
          year: this.fechas.anho
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`
          }
        })
      //return rows.data
      //console.log(rows.data)
      this.movimientos = rows.data     
      } catch (error) {
        console.log(error.message)
      } finally {
        loader.hide();
      }
      
    },
    formatNumber (n) {
      if ( n >= 0 ) {
        n = String(n).replace(/\D/g, "");
      } else {
        n = '-' + String(n).replace(/\D/g, "");
      }
      return n === '' ? n : Number(n).toLocaleString();
    },
  },
  async mounted() {
    this.cuentas = await this.getCuentas()
  }
};

</script> 

<style>
.formulario {
  margin: 2em;
  text-align: left;
  padding-top: 20px;
}
.texto_verde {
  font-weight: 600;
  color: green;
}
.texto_rojo {
  font-weight: 600;
  color: red;
}
.texto_negrita {
  font-weight: 600;
}
</style>